import "./src/css/icons/style.css";
import "./src/css/fonts/Bebas/style.css";
import "./src/css/preloader/preloader.scss";
import "./src/css/icons/fonts/icomoon/style.css";
import "./src/css/icons/share/style.css";
import "./src/css/global.css";
import "typeface-roboto";
import "flag-icon-css/css/flag-icon.min.css";
import "./src/css/icons/phones/style.css";

export const onInitialClientRender = () => {
    setTimeout(function() {
        document.getElementById("preloader").style.display = "none";
    }, 1000)
}